import { Feedback as FeedbackData } from '@silvertours/common-landingpages-view';
import { useTranslations } from 'next-intl';

import { Ui } from '@silvertours/front-shared';
import { FeedbackSummary } from './FeedbackSummary';
import { ReviewList } from './ReviewList';
import { FeedbackContainer } from './Reviews.styles';

type FeedbackProps = FeedbackData & {
  locationName?: string;
  hideSummaryDescription?: boolean;
  largeReviews?: boolean;
};

const Feedback = (props: FeedbackProps) => {
  const t = useTranslations(
    'features.trustLegacy.feedback.feedbackGroup.groupLink',
  );

  const { hideSummaryDescription, groupLink } = props;

  const name = t('name');
  const path = t('path');
  return (
    <FeedbackContainer hasSummary={!hideSummaryDescription}>
      <FeedbackSummary {...props} />
      <ReviewList {...props} />
      {!!groupLink && (
        <span>
          <Ui.TextLink text={name} href={path} /> &nbsp;&gt;
        </span>
      )}
    </FeedbackContainer>
  );
};

export { Feedback };
